import { Flex, Spinner } from "@chakra-ui/react";
import React from "react";

const Loading = ({ mini }) => {
  return (
    <Flex
      w={mini ? "50px" : "100%"}
      justify="center"
      align="center"
      h={mini ? "50px" : "70vh"}
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="#E2E8F0"
        color="#ff6e6c"
        w={mini ? "100%" : "100px"}
        h={mini ? "100%" : "100px"}
      />
    </Flex>
  );
};

export default Loading;
